import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { IDropDown } from 'src/app/interfaces/drop-down';
import { IMyArtifact } from 'src/app/interfaces/my-artifact';
import { ArtifactService } from 'src/app/services/artifact/artifact.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { DatePipe } from '@angular/common';
import * as fileSaver from 'file-saver';
import { ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-my-artifacts',
  standalone: false,
  templateUrl: './my-artifacts.component.html',
  styleUrl: './my-artifacts.component.css'
})
export class MyArtifactsComponent implements OnInit, AfterViewInit{
  constructor(private confirmationService: ConfirmationService,private artifactSrv : ArtifactService,
     private sharedService: SharedService, private datePipe: DatePipe, private changeDetection: ChangeDetectorRef) { }
  isSpinnerHidden: boolean = true;
  isNextButtonShown: boolean = false;
  isPriorButtonShown: boolean = false;
  nextPageToken: string = '';
  pageSize: number = 15;
  artifactGridCols: any[] = [];

  artifactTypes: IDropDown[] = [];
  artifactStatusOptions: IDropDown[] = [];
  
  selectedArtifactStatuses: string[] = []; // Stores selected statuses
  selectedArtifactType: string ='0';
 
  selectedDateFrom!: string;
  selectedDateTo!: string;
 
  artifacts: IMyArtifact[] = [];
  @ViewChild('gridData') gridData:any;

  ngOnInit(): void {
    this.selectedDateFrom = this.sharedService.getCurrentDate(); 
    this.selectedDateTo = this.sharedService.getCurrentDate();  
    this.setArtifactGridCols();
  }
  ngAfterViewInit(): void {
    
    this.getArtifactTypes();
    this.getArtifacts();
  }

  setArtifactGridCols() {
    this.artifactGridCols = [
      { field: 'artifactSessionId', header: 'Artifact Id', width: '7%', display: 'table-cell' },
      { field: 'artifactName', header: 'Artifact Name', width: '20%', display: 'table-cell' },
      { field: 'artifactDescription', header: 'Artifact Description', width: '28%', display: 'table-cell' },
      { field: 'brandsCodes', header: 'Brands', width: '10%', display: 'table-cell' },
      { field: 'artifactRequestedTime', header: 'Request time', width: '20%', display: 'table-cell' },
      { field: 'artifactStatus', header: 'Status', width: '10%', display: 'table-cell' },
      { field: 'download', header: 'Download', width: '7%', display: 'table-cell' }
    ] 
  }

  getArtifactTypes() {
    this.isSpinnerHidden = false;
    this.changeDetection.detectChanges();
    this.artifactSrv.getArtifactTypes().subscribe({
      next: (response) => {
        if (response) {
          this.artifactTypes = [{ label: 'ALL', value: '0' }, ...response];
        }    
        this.isSpinnerHidden = true;
        
      },
      error: (error) => {
        this.alertTheUser("Error", "Unable to retrieve artifact types.");
        this.isSpinnerHidden = true;      
      },
      complete: () => {
      }
    });
  }

  getArtifacts() {
    this.gridData.reset();
    if (!this.selectedDateFrom || !this.selectedDateTo) {
      this.alertTheUser("Warning","Please select a date range.");
      return;
    }
    this.isSpinnerHidden = false;
    this.artifactSrv.getMyArtifacts(this.selectedArtifactType, this.selectedDateFrom, this.selectedDateTo).subscribe({
      next: (response) => {
        if (response) {
          this.artifacts = response;

        //Populate artifactStatusOptions dynamically
        const uniqueStatuses = Array.from(new Set(this.artifacts.map(artifact => artifact.artifactStatus)));
        this.artifactStatusOptions = uniqueStatuses.map(status => ({
          label: this.formatArtifactStatus(status), // Format the status for display
          value: status
        }));
        }
        
        this.isSpinnerHidden = true;
      },
      error: (error) => {
        this.alertTheUser("Error", "Unable to retrieve artifacts.");
        this.isSpinnerHidden = true;      },
      complete: () => {
        this.isSpinnerHidden = true;
      }
    });
  }

  onSearchClick(event: any) {
    this.getArtifacts();
  }

  onClearClick(event: any) {

  }

  onDateChange(event: Date, field: 'selectedDateFrom' | 'selectedDateTo'): void {
    const formattedDate = this.datePipe.transform(event, 'yyyy-MM-dd') || '';
    if (field === 'selectedDateFrom') {
      this.selectedDateFrom = formattedDate;
  
      // Ensure selectedDateTo is not earlier than selectedDateFrom
      if (this.selectedDateTo && this.selectedDateTo < this.selectedDateFrom) {
        this.alertTheUser('Warning','The "Date To" cannot be earlier than "Date From".');
        this.selectedDateTo = this.selectedDateFrom; // Adjust Date
      }
    } else if (field === 'selectedDateTo') {
      this.selectedDateTo = formattedDate;
  
      // Ensure selectedDateTo is not earlier than selectedDateFrom
      if (this.selectedDateTo < this.selectedDateFrom) {
        this.alertTheUser('Warning','The "Date To" cannot be earlier than "Date From".');
        this.selectedDateFrom = this.selectedDateTo; // Adjust Date
      }
    }
  }


    onFileDownload(event: any) {
          this.isSpinnerHidden = false;    
          let fileGuid = event.sessionGuid; 
          this.artifactSrv.downloadArtifact(event.artifactSessionId).subscribe({
              next: (response) => {
                if (response) {
                      const contentDisposition = response.headers.get('Content-Disposition');
                      let filename = 'download';

                      if (contentDisposition) {
                        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        const matches = filenameRegex.exec(contentDisposition);
                        
                        if (matches != null && matches[1]) {
                            filename = matches[1].replace(/['"]/g, ''); // remove quotes if present
                          }

                      }
                      this.isSpinnerHidden = true;
                      const contentType = response.headers.get('Content-Type') || 'application/octet-stream';

                      if (response.body) {
                        const blob = new Blob([response.body], { type: contentType });
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = filename;
                        a.click();
                        window.URL.revokeObjectURL(url);
                      } else {
                        console.error('Download failed: response body is null');
                      }
                    }    
                this.isSpinnerHidden = true;
                
              },
              error: (error) => {
                this.alertTheUser("Error", "Unable to retrieve artifact.");
                this.isSpinnerHidden = true;      
              },
              complete: () => {
              }
            });

  
    }

    formatArtifactStatus(status: string): string {
        if (!status) return '';
        // Convert the status to a user-friendly format
        status = status
          .toLowerCase() // Convert to lowercase
          .replace(/_/g, ' ') // Replace underscores with spaces
          .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
          if(status.startsWith("Error")) {
            status = status.replace("Error", "Error in");
          }
          return status;
    }


    onArtifactStatusFilterChange(): void {
      if (this.selectedArtifactStatuses.length > 0) {
        // Filter the table based on selected statuses
        this.gridData.filter(this.selectedArtifactStatuses, 'artifactStatus', 'in');
      } else {
        // Clear the filter if no statuses are selected
        this.gridData.filter(null, 'artifactStatus', 'in');
      }
    }

  alertTheUser(header: string, message: string) {
    this.confirmationService.confirm({
      message: message,
      header: header,
      key: 'my-generated-artifacts',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: "Ok",
      rejectVisible: false,
      acceptButtonStyleClass: "p-button-info wal-info  p-button-rounded",
      accept: () => {
         return;
       }
    });
  }

}
